import axios, { AxiosInstance, AxiosResponse } from "axios";
import { merchantCODResponseProps } from "../@Types/DRO/MerchantCODResponse";
export class MerchantCODApi {
  public static api = new MerchantCODApi();
  private instance: AxiosInstance;
  constructor() {
    this.instance = axios.create({
      baseURL: "https://pre-micro.bcykal.com/",
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
  }
  getToken() {
    return localStorage.getItem("token");
  }

  merchantCODList(
    merchantId: number
  ): Promise<AxiosResponse<merchantCODResponseProps>> {
    let apiUrl = "mobycy/on-demand/dashboard/v1/merchant/cod-details";
    return this.instance.get<merchantCODResponseProps>(apiUrl, {
      params: {
        merchantId: merchantId,
      },
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
  updateMerchantCODStatus(id: number, codStatus: boolean): Promise<any> {
    return this.instance
      .post<any>(
        `mobycy/on-demand/dashboard/v1/merchant/update/cod-status`,
        {
          id,
          codStatus,
        },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      )
      .then((e) => {
        return e.data;
      });
  }
  updateMerchantCODLimit(id: number, codLimit: number): Promise<any> {
    return this.instance
      .post<any>(
        `mobycy/on-demand/dashboard/v1/merchant/update/cod-limit`,
        {
          id,
          codLimit,
        },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      )
      .then((e) => {
        return e.data;
      });
  }
}
